import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'assets/index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Switch } from 'react-router-dom';
import Login from 'pages/Login';
import PageAuth from 'features/Auth/PageAuth';
import App from './App';
import User from './pages/User';
import Books from './portal/books/Books'
import ReviewBook from './components/books'
import CreateBook from './portal/books/CreateBook'
import LifeInsurance from 'pages/LifeInsurance'
//import BillsPayment from './components/billsPayment'
import ProtectedRoute from 'context/ProtectedRoute';
import Home from 'pages/Home';
import store from './context/configureStore';
import { Provider } from 'react-redux'


import Symbol_observable from 'symbol-observable';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<Provider store={store}>
	<React.StrictMode>
		<BrowserRouter basename={'/'}>
			<Routes>
				<Route path='/auth' element={<PageAuth />}>
					<Route path='login' element={<Login/>} />
					
				</Route>
				<Route path="/" element={<App />}>
					<Route path='' element={
						<ProtectedRoute>
							<Home /> 
						</ProtectedRoute>
					} />
					<Route path='user' element={
						<ProtectedRoute>
							<User />
						</ProtectedRoute>
					} />
					<Route path='books' element={
						<ProtectedRoute>
							<Books />
						</ProtectedRoute>
					} />
					<Route path='reviewbook' element={
						<ProtectedRoute>
							<ReviewBook />
						</ProtectedRoute>
					} />
					<Route path='books/create' element={
						<ProtectedRoute>
							<CreateBook />
						</ProtectedRoute>
					} />
					<Route path='books/edit/:id' element={
						<ProtectedRoute>
							<CreateBook />
						</ProtectedRoute>
					} />
					
					<Route path='calculator' element={
						<ProtectedRoute>
							<LifeInsurance />
						</ProtectedRoute>
					} />
						
					{/*
					<Route path='bills' element={
						<ProtectedRoute>
							<BillsPayment />
						</ProtectedRoute>
					} />
					 */}
				</Route>
				<Route path='/hitungasuransi' element={
							<LifeInsurance />
				} />

				
			</Routes>
		</BrowserRouter>
	</React.StrictMode>
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
